<template>
  <div class="new-event-hotel-list">
    <div class="text-xl font-medium mb-16" style="min-width: 224px">{{ title }}</div>
    <div v-if="tags.length > 1" class="tags relative w-full overflow-scroll">
      <div class="tag" v-for="(tag, index) in tags" :key="`tag-${tag.id}`" :class="activeIndex === index && 'active'" @click="activeIndex = index">
        {{ tag.name }}
      </div>
    </div>
    <div class="relative mx-auto event-container container-anchor mt-32">
      <swiper :options="options" :ref="`swiper-pickapage-${cid}`" class="pickapageSwiper__wrap justify-center" style="flex-wrap: wrap">
        <swiper-slide v-for="(hotelUUID, index) in hotelList" :key="`swiper-pickapage-${index}`">
          <hotelCard :hotel="list[hotelUUID]" style="width: 250px; flex: 1;"/>
        </swiper-slide>
      </swiper>
    </div>
    <div v-show="swiperButtonShow" class="relative hidden md:flex items-center justify-end mt-8">
      <div class="hidden md:flex items-center justify-center" style="width: fit-content; gap: 8px; margin-right: 60px">
        <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
          <i class="owl-direction-left"></i>
        </div>
        <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import imgInfo from '@/utils/imgInfo'
import hotelCard from './hotelCard.vue'

export default {
  name: 'NewEventHotelList',
  props: {
    title: {
      type: String,
      default: ''
    },
    hotels: {
      type: Array,
      default: () => []
    },
    list: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    hotelCard
  },
  data () {
    return {
      MAGNIFACATION: 1.5,
      coverExist: false,
      cid: this._uid,
      options: {
        spaceBetween: 24,
        slidesPerView: 'auto',
        initialSlide: 0,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        loop: false
      },
      activeTag: '',
      activeIndex: 0,
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      initWidth: 'initWidth'
    }),
    tags () {
      return this.hotels.reduce((acc, curr) => {
        acc.push(curr.tag)
        return acc
      }, [])
    },
    // swiperButtonShow() {
    //   if ((this.initWidth >= 768 && this.initWidth <= 830) && this.hotelList.length > 2) {
    //     return true
    //   } else if ((this.initWidth > 830 && this.initWidth <= 1100) && this.hotelList.length > 3) {
    //     return true
    //   } else if (this.initWidth > 1101 && this.hotelList.length > 4) {
    //     return true
    //   }
    //   return false
    // },
    hotelList () {
      return this.hotels[this.activeIndex].hotelUUIDs
    },
    hotelCardHomeImageWidth () {
      if (this.initWidth >= 1200) {
        return 280
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 172
      } else {
        return 380
      }
    }
  },
  methods: {
    goToHotel: function (hotel) {
      return {
        name: 'HotelDetail',
        params: { hotelId: hotel.hotelUUID },
        query: {
          ...this.$route.query,
          externalId: hotel.hotelUUID,
          searchId: hotel.hotelUUID,
          search: hotel.hotelNameLocal,
          searchType: 'hotel',
          source: hotel.source
        }
      }
    },
    hotelCover: function (hotel) {
      if (hotel.image) {
        return `${hotel.image}?width=${this.hotelCardHomeImageWidth * this.MAGNIFACATION}&format=webp`
      }
      return require('@/assets/images/default-room.jpg')
    }
  },
  // async mounted () {
  //   const exist = await imgInfo.exist(this.hotel.image)
  //   this.coverExist = exist
  // },
  async mounted () {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    // const exist = await imgInfo.exist(this.hotel.image)
    // this.coverExist = exist

    this.$nextTick(() => {
      const swiperWidth = this.$refs[`swiper-pickapage-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`swiper-pickapage-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>
<style lang="sass" scoped>
.new-event-hotel-list
  // @apply mt-96
  .tags
    @apply relative flex overflow-scroll
    gap: 16px
    // width: fit-content
    scroll-behavior: smooth
    scrollbar-width: none
    .tag
      @apply py-8 px-16 border-2 border-grey-light cursor-pointer
      border-radius: 10px
      width: fit-content
      flex-basis: unset
      flex-shrink: 0
      -webkit-box-flex: 0
      flex-grow: 0
      transition: .3s all
      &.active
        @apply border-grey-darkest
      &:hover
        @apply border-grey-darkest
  &__content
    @apply py-8 px-4
  .swiper-slide
    @apply flex items-center justify-center h-full
    width: fit-content
    align-items: stretch
  .coverImage
    @apply bg-grey-lightest
    border-radius: 1.25rem
    padding-top: imageRatio(324, 192)
    background:
      position: center
      repeat: no-repeat
      size: cover
</style>
<style lang="sass">
.new-event-hotel-list
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-lightest
    position: relative !important
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    z-index: 8
    i[class*=owl-direction]
      @apply text-grey-darkest
      font-size: 18px
  .swiper-button-prev
    left: initial
    // @screen sm
    //   left: -5px !important
  .swiper-button-next
    right: initial
    // @screen sm
    //   right: -5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed
</style>
